<div
  class="px-16 py-10 rounded-3xl uploader-status flex flex-col items-center justify-center align-middle"
>
  <div class="py-6 text-xl font-semibold text-center">Rechazar usuario</div>
  <p>Selecciona el motivo de rechazo</p>

  <form
    class="grid grid-cols-1 gap-4 mt-5"
    [formGroup]="formCompliance"
    *ngIf="formCompliance"
  >
    <div class="grid grid-cols-1">
      <mat-form-field appearance="outline" class="modern-field">
        <mat-label>Comentario compliance</mat-label>
        <mat-select
          formControlName="comentarioCompliance"
          name="comentarioCompliance"
        >
          <mat-option>SIN SELECCIONAR</mat-option>
          <mat-option
            *ngFor="let comentario of comentariosCompliance"
            [value]="comentario.comentarioID"
          >
            {{ comentario.descripcion | uppercase }}
          </mat-option>
        </mat-select>
      </mat-form-field>
    </div>
  </form>
  <div class="flex flex-row gap-4">

    <button class="mt-4" (click)="onNoClick()"
      style="display: inline-flex; align-items: center; gap: 6px; padding: 8px 24px; background: white; color: #374151; border: 1px solid #d1d5db; border-radius: 10px; font-weight: 600; font-size: 0.85rem; cursor: pointer; transition: all 0.2s ease;"
      onmouseover="this.style.background='#f3f4f6'"
      onmouseout="this.style.background='white'"
    >
      <mat-icon> close</mat-icon>
      Cancelar
    </button>
    <button [disabled]="!formCompliance.valid"
      class="mt-4"
      (click)="rechazarUsuario()"
      style="display: inline-flex; align-items: center; gap: 6px; padding: 8px 24px; background: #dc2626; color: white; border: none; border-radius: 10px; font-weight: 700; font-size: 0.85rem; cursor: pointer; transition: background 0.2s ease;"
      onmouseover="this.style.background='#b91c1c'"
      onmouseout="this.style.background='#dc2626'"
    >
      <mat-icon> check</mat-icon>
      Rechazar
    </button>
  </div>

</div>
